import { render, staticRenderFns } from "./LotteryResult.vue?vue&type=template&id=632c2a79&scoped=true&"
import script from "./LotteryResult.vue?vue&type=script&lang=js&"
export * from "./LotteryResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c2a79",
  null
  
)

export default component.exports